<template>
    <div class="card-gray rounded shadow pt-4 px-3">
        <div class="text-center">
            <p>{{ title }}</p>
            <p v-if="channelCount" class="text-3lg mb-4 font-bold">{{ channelCount }}+ Channels</p>
            <img class="m-auto mb-4" :src="'/assets/network-icons/' + image" :alt="imageAlt">
            <div class="mb-4 flex justify-between items-center content-center">
                <PricePerMonth
                    :price="price"
                    size="small"
                />
                <button
                    class="buyflow-button flex items-center"
                    :class="{ 'active': isSelected }"
                    @click="isSelected? $emit('deselect'): $emit('select')"
                >
                    <template v-if="isSelected">
                        <IconCheck class="mr-1" />
                        Selected
                    </template>
                    <template v-else>
                        <IconPlus class="mr-1" data-cy="add-tv-variety" />
                        Select
                    </template>
                </button>
            </div>
            <a  v-if="channelCount"
                @click.prevent="$emit('show-channel-lineup')"
                href="#"
                class="mb-4 block underline"
            >
                View Channel Lineup
            </a>
        </div>
    </div>
</template>

<script>
    import IconPlus from "@/atoms/icons/IconPlus"
    import IconCheck from "@/atoms/icons/IconCheck"
    import PricePerMonth from "@/atoms/PricePerMonth"
    import IconCircleExclamation from "@/atoms/icons/IconCircleExclamation"
    export default {
        name: 'TVPackagesCards_Card',
        components: {
            IconPlus,
            IconCheck,
            PricePerMonth,
            IconCircleExclamation,
        },
        props: {
            title: {
                type: String,
                required: true,
            },
            channelCount: {
                type: Number,
                required: false,
            },
            image: {
                type: String,
                required: true,
            },
            imageAlt: {
                type: String,
                required: true,
            },
            price: {
                type: Number,
                required: true,
            },
            isSelected: {
                type: Boolean,
                required: false,
                default: false,
            },
            channelPackage: {
                type: Object,
                required: false,
            },
        },
    }
</script>

<style scoped>
    .card-gray {
        background: #F9F9F9;
    }
</style>
